import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import Select from "react-select";
import { createBreedType , updateBreedType } from "../../actions/addBreedType";
import { forceInputUppercase } from "../../utils/helper";
import { fetchBreedAttributes  } from '../../actions/breedAttribute';
import {fetchBreedCategories} from '../../actions/breedCategory'


const $ = window.$;
class AddBreedType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      PetId: "",
      EmailTemplateId : "",
      breedType: "",
      crossBreed : false,
      breedAttributes : [],
      loading: false,
      inputNotValid: false,
      BreedId : null,
    };
  }

  changePet = selected => {
    this.setState({ PetId: selected.value });
  };

  changeEmail = selected => {
    this.setState({ EmailTemplateId: selected.value });
  };

  changeCrossBreed = (event) => {
    this.setState({ 
      crossBreed : event.target.checked
 })
  }

  selectAttributes = selected => {
    this.setState({ 
      breedAttributes : selected
 })
  }

  handleChange = event => {
    forceInputUppercase(event);
    const value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };
  submit(e) {
    this.setState({ loading: true });
    let data = {
      breed_type: this.state.breedType,
      PetId: this.state.PetId,
      BreedCategoryId: this.state.EmailTemplateId,
      cross_breed : this.state.crossBreed,
      breedAttributes : this.state.breedAttributes,
      PetShopId: this.props.petShop.currentPetshop.id
    };
    let valid = this.state.breedType.length > 0 && this.state.PetId && this.state.EmailTemplateId;
         
    if (valid) {
      if(this.state.BreedId){
        data.id = this.state.BreedId;
        this.props.updateBreedType(data);
        this.props.actionBreed();
      }else{
        this.props.createBreedType(data);
      } 
    } else {
      e.preventDefault();
      this.setState({ inputNotValid: true });
      NotificationManager.warning("Incomplete information.");
      this.setState({ loading: false });
    }
  }

  closeModal = () => {
    $("#add_breed_type").modal("hide");
    this.resetState();
    this.props.actionBreed();
  };
  resetState = () => {
    this.setState({
      PetId: "",
      breedType: "",
      loading: false,
      inputNotValid: false,
      BreedId : null,
      crossBreed : false,
      breedAttributes : [],
    });
  };

  componentDidMount() {  
    this.props.fetchBreedCategories();
    this.props.fetchBreedAttributes();
   }
  componentWillReceiveProps = nextProps => {

    if (nextProps.toa && this.props.toa !== nextProps.toa) {
      let options = [];
      nextProps.toa.map(p => {
        options.push({ label: p.type, value: p.id });
      });
      this.setState({ toa: options });
      if (nextProps.toa.length > 0) {
        this.setState({ PetId: nextProps.toa[0].id });
      }
    }

    if (nextProps.selectedBreedData 
      && nextProps.selectedBreedData.id
      && nextProps.selectedBreedData.id !== this.state.BreedId) {
        let selectedAttributes = nextProps.selectedBreedData.BreedAttributeLists.map(att =>{
           let a = {label :"" ,value : 0};
           a.label = att.BreedAttribute.name;
           a.value = att.BreedAttribute.id;
           return a;
        })
       this.setState({
        BreedId : nextProps.selectedBreedData.id,
        PetId : nextProps.selectedBreedData.PetId,
        breedType : nextProps.selectedBreedData.breed_type,
        EmailTemplateId : nextProps.selectedBreedData.BreedCategoryId,
        crossBreed : nextProps.selectedBreedData.cross_breed, 
        breedAttributes : selectedAttributes  
        }, () => {               
          $("#add_breed_type").modal("show");
       });
    }

    if(nextProps.emailTemplates && this.props.emailTemplates !== nextProps.emailTemplates){
      let options = [];
      nextProps.emailTemplates.map(p => {
        options.push({ label: p.name, value: p.id });
      });
      this.setState({ emailTemplates: options });
      if (nextProps.emailTemplates.length > 0) {
        this.setState({ EmailTemplateId: nextProps.emailTemplates[0].id });
      }
    }

    if(nextProps.attributes && this.props.attributes !== nextProps.attributes){
      let options = [];
      nextProps.attributes.map(p => {
        options.push({ label: p.name, value: p.id });
      });
      this.setState({ attributes: options });
      
    }

    if (nextProps.breedTypeUpdated && this.props.breedTypeUpdated  !== nextProps.breedTypeUpdated) {
      this.resetState()
      NotificationManager.success("Breed Type Updated");
      $("#add_breed_type").modal("hide");
    }

    if (nextProps.breedType && this.props.breedType !== nextProps.breedType) {
      this.setState({ breedType: "", loading: false });
      NotificationManager.success("Breed Type Added");
      $("#add_breed_type").modal("hide");
    }
    if (nextProps.breedTypeError && this.props.breedTypeError !== nextProps.breedTypeError) {
      this.setState({ breedType: "", loading: false });
      if (nextProps.breedTypeError.name === 'SequelizeUniqueConstraintError')
        NotificationManager.error("Breed type already exists");
      else
        NotificationManager.error("Failed to add Breed Type.");
      $("#add_breed_type").modal("hide");
    }
  };

  render() {
    const { PetId, toa , crossBreed, attributes , emailTemplates , EmailTemplateId , breedAttributes} = this.state;
    return (
      <div
        className="modal fade show"
        id="add_breed_type"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                {!this.state.BreedId ? "New Breed Type" : "Edit Breed Type"}
                  </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                      {/* <div className="m-form__heading">
                                      <h3 className="m-form__heading-title">User Details</h3>
                                  </div> */}

                      <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                          Animal Type:
                          </label>
                        <div className="col-xl-9 col-lg-9">
                          <Select
                            options={toa}
                            value={PetId}
                            name="PetId"
                            onChange={this.changePet}
                            placeholder="Select the pet"
                          />
                          <span className="m-form__help">
                            Please select pet type
                            </span>
                        </div>
                      </div>

                      <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                          Breed Type:
                          </label>
                        <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="breedType"
                            onChange={e => this.handleChange(e)}
                            value={this.state.breedType}
                            className="form-control m-input"
                            placeholder=""
                          />
                          <span
                            className={
                              this.state.inputNotValid && !this.state.breedType
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter breed type
                            </span>
                        </div>
                      </div>

                      <div className="form-group m-form__group row pt-2 pb-0" >
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <label className="m-checkbox m-checkbox--bold m-checkbox--state-success">
																<input type="checkbox" defaultChecked={crossBreed}  value={crossBreed} checked={crossBreed} onChange={e => this.changeCrossBreed(e)}/> 
																<span></span>
                                Cross Breed {this.state.BreedId ? ( <label style={{color : "red"}}> (Change if necessary) </label>)   : (null)}
													</label>
                          </div>
                      </div>
                      <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              Email Template:
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <Select
                            options={emailTemplates}
                            value={EmailTemplateId}
                            name="EmailTemplateId"
                            onChange={this.changeEmail}
                            placeholder="Select the email template"
                          />
                          <span
                            className={
                              this.state.inputNotValid && !this.state.EmailTemplateId
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please select email template
                            </span>
                          </div>
                      </div>
                      <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                              Attributes:
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <Select
                            multi={true}
                            options={attributes}
                            value={breedAttributes}
                            onChange={this.selectAttributes}
                            placeholder="Select breed attributes"
                          />
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                      </button>
                    <button
                      onClick={(e) => this.submit(e)}
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                      </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  breedType: state.addBreedTypeReducer.setBreedType,
  toa: state.addAnimalTypeReducer.animalTypes,
  breedTypeError: state.addBreedTypeReducer.setBreedTypeError,
  attributes : state.breedAttributeReducer.breedAttributes, 
  emailTemplates : state.breedCategoryReducer.breedCategories, 
  breedTypeUpdated : state.addBreedTypeReducer.updateBreedType
});

const mapDispatchToProps = dispatch => ({
  createBreedType: data => {
    dispatch(createBreedType(data));
  },
  updateBreedType : data => {
    dispatch(updateBreedType(data));
  },
  fetchBreedAttributes : () => {
    dispatch(fetchBreedAttributes());
  },
  fetchBreedCategories : () => {
    dispatch(fetchBreedCategories());
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddBreedType)
);